import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { switchMap, withLatestFrom } from "rxjs/operators";
import * as CompanySearchActions from "../contact-search/search.actions";
import * as ContactSearchActions from "../contact-search/search.actions";
import { NavigateAction } from "../router/router.actions";
import { selectRouterState } from "../router/router.selectors";
import { IStore } from "../store";
import * as ApplicationActions from "./application.actions";

@Injectable()
export class ApplicationEffects {
  companySortingChangedAction$; // Объявляем как свойство

  constructor(
    private actions: Actions,
    private store: Store<IStore>,
  ) {


    this.companySortingChangedAction$ = createEffect(() => {
      return this.actions.pipe(
        ofType(ApplicationActions.SearchAction),
        withLatestFrom(this.store.select(selectRouterState)),
        switchMap(([action, routerState]) => {
          const url = ["/contact", "/company"].includes(routerState.state.url)
            ? routerState.state.url
            : "/contact";

          const contactActions = [
            ContactSearchActions.SearchAction({ searchTerm: action.searchTerm }),
            CompanySearchActions.ClearSearchAction({ searchTerm: action.searchTerm }),
          ];

          const companyActions = [
            CompanySearchActions.SearchAction({ searchTerm: action.searchTerm }),
            ContactSearchActions.ClearSearchAction({ searchTerm: action.searchTerm }),
          ];

          return [
            ...(url === "/contact" ? contactActions : []),
            ...(url === "/company" ? companyActions : []),
            ApplicationActions.MergeStateAction({ newState: { searchTerm: action.searchTerm } }),
            NavigateAction({ payload: { path: [url] } }),
          ];
        })
      );
    });
  }
}